module.exports = __webpack_public_path__ + "img/icon-acciones.7d9848d8.svg";